import { Context } from 'vm'
import { ConsumptionStandardsApi, HttpClient } from '../../../api'
import { ConsumptionStandards, ConsumptionStandardsService } from './consumptionStandards'

export class RemoteConsumptionStandardsService implements ConsumptionStandardsService {
  private api: ConsumptionStandardsApi

  constructor(httpClient: HttpClient) {
    this.api = new ConsumptionStandardsApi(httpClient, undefined, '')
  }

  async get(ctx: Context): Promise<ConsumptionStandards> {
    const result = await this.api.consumptionStandardsGetObject(ctx)

    return result.body.object
  }
}
